import React from "react";
import { ReactComponent as YourSvg } from "../../assets/logos/sosmascaras.svg";

const SosMascarasIcon = () => {
  return <YourSvg />;
};

export default SosMascarasIcon;